var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('FilterIcon',{attrs:{"title":"Conditional Display Criteria","fill":'currentColor'}}),_c('FilterGroup',{staticClass:"filter-inline-viewer",attrs:{"rules":_vm.rules,"group":_vm.conditions}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }